angular.module('bribac.views.listOrganizations', [
  'bribac.translations',
  'bribac.entities.kinds',
  'bribac.entities.organizationFactory',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.filterUtils',
  'bribac.components.whenLoaded',
  'bribac.components.organizationDetails',
  'bribac.components.filterActive'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/organization', {
      templateUrl: 'list-organizations-view.html',
      controller: 'ListOrganizationsViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('ListOrganizationsViewCtrl', function(
    $scope,
    $filter,
    KINDS,
    organizationFactory,
    api,
    filterUtils
  ) {
    var $ctrl = this

    $ctrl.currentPage = 1
    $ctrl.pageSize = 10
    $ctrl.total = 0

    $ctrl.desc = false;

    $ctrl.filter = 'active'
    $ctrl.sortOrder = 'asc'

    $ctrl.onPageChange = function () {
      getOrganizations()
    }

    // Reload organizations list from REST API upon change of either sort (no params), pageSize or filter
    function getOrganizations(newValue, oldValue) {
      // Check if there is coming change of $watchGroup callback and reset the page only if when filter changes
      if (newValue && oldValue) {
        $ctrl.currentPage = 1
      }
      $ctrl.organizationsPromise = api.getView(KINDS.ORGANIZATION + '?status=' + $ctrl.filter
        + "&sortBy=name&sortOrder=" + $ctrl.sortOrder + "&page=" + $ctrl.currentPage
        + "&size=" + $ctrl.pageSize).then(function (request) {
          $ctrl.organizations = request.data.list
          $ctrl.total = request.data.total
      })
    }

    $ctrl.sortByName = function () {
      $ctrl.desc = !$ctrl.desc;
      $ctrl.sortOrder = $ctrl.desc ? "desc" : "asc";
      getOrganizations();
    }

    // Check $watchGroup callback method, watch if the change is from filter and pageSize
    // $watchGroup() allows you to watch multiple expressions in the same callback and see coming changes
    $scope.$watchGroup(["$ctrl.pageSize", '$ctrl.filter'], getOrganizations)
  });
